import React from "react";
import { SpecificImportModal } from "../Common/Settings/Contents/Import";

const AddFileSignatureModal = ({
  signal = "add-signatures-file",
  method = "update",
  ...settings
}) => <SpecificImportModal {...settings} {...{ signal, method }} />;

export default AddFileSignatureModal;
